(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ingredients-filter"] && !Shopify.designMode) return;
  try {
    (() => {
    // Check if we're on mobile (767px and below)
    const isMobile = () => window.innerWidth <= 767;

    const containers = document.querySelectorAll('.ingredients-filter[data-block-id]');
    containers.forEach(container => {
      const blockId = container.dataset.blockId;
      if (!blockId) return;

      const buttons = container.querySelectorAll('.ingredients-filter__button');
      const cards = container.querySelectorAll('.ingredient-card');
      const showMoreWrapper = container.querySelector(`#show-more-wrapper-${blockId}`);
      const showMoreButton = container.querySelector(`#show-more-button-${blockId}`);

      if (buttons.length === 0 || cards.length === 0) return;

      let isExpanded = false;

      const allCards = Array.from(cards);
      // Remove CSS class-based hiding and use JavaScript for consistency
      allCards.forEach(card => {
        card.classList.remove('ingredient-card--hidden');
      });

      // Function to handle show more logic based on screen size
      const handleShowMore = (filterValue, visibleCards) => {
        if (!showMoreWrapper) return;

        if (isMobile() && filterValue === 'all' && visibleCards.length > 6 && !isExpanded) {
          // Mobile: Show first 6, hide rest
          visibleCards.forEach((card, index) => {
            if (index < 6) {
              card.style.display = '';
            } else {
              card.style.display = 'none';
            }
          });
          showMoreWrapper.style.display = 'block';
        } else {
          // Tablet/Desktop or expanded: Show all cards
          visibleCards.forEach(card => {
            card.style.display = '';
          });
          showMoreWrapper.style.display = 'none';
        }
      };

      // Initialize on page load
      if (isMobile() && allCards.length > 6 && showMoreWrapper) {
        allCards.forEach((card, index) => {
          if (index >= 6) {
            card.style.display = 'none';
          } else {
            card.style.display = '';
          }
        });
        showMoreWrapper.style.display = 'block';
      } else {
        // Tablet/Desktop: Show all cards
        allCards.forEach(card => {
          card.style.display = '';
        });
        if (showMoreWrapper) {
          showMoreWrapper.style.display = 'none';
        }
      }

      // Show more button handler
      if (showMoreButton) {
        showMoreButton.addEventListener('click', () => {
          const activeButton = container.querySelector('.ingredients-filter__button--active');
          const filterValue = activeButton ? activeButton.dataset.filter : 'all';
          
          if (filterValue === 'all' && isMobile()) {
            // Show all cards
            allCards.forEach(card => {
              card.style.display = '';
              card.classList.remove('ingredient-card--hidden');
              card.setAttribute('aria-hidden', 'false');
            });
            if (showMoreWrapper) {
              showMoreWrapper.style.display = 'none';
            }
            isExpanded = true;
          }
        });
      }

      buttons.forEach(button => {
        button.addEventListener('click', () => {
          const filterValue = button.dataset.filter;
          isExpanded = false;

          // Update button states
          buttons.forEach(btn => {
            btn.classList.remove('ingredients-filter__button--active');
            btn.setAttribute('aria-selected', 'false');
          });
          button.classList.add('ingredients-filter__button--active');
          button.setAttribute('aria-selected', 'true');

          // Filter cards
          const visibleCards = [];
          cards.forEach(card => {
            const cardCategories = card.dataset.categories;
            
            if (filterValue === 'all') {
              card.setAttribute('aria-hidden', 'false');
              visibleCards.push(card);
            } else if (cardCategories) {
              const categoriesArray = cardCategories.split(',').map(cat => cat.trim());
              if (categoriesArray.includes(filterValue)) {
                card.setAttribute('aria-hidden', 'false');
                visibleCards.push(card);
              } else {
                card.style.display = 'none';
                card.setAttribute('aria-hidden', 'true');
              }
            } else {
              card.style.display = 'none';
              card.setAttribute('aria-hidden', 'true');
            }
          });

          // Handle show more button visibility based on screen size
          handleShowMore(filterValue, visibleCards);
        });
      });

      // Handle window resize to update state when switching between mobile/desktop
      let resizeTimeout;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          const activeButton = container.querySelector('.ingredients-filter__button--active');
          const filterValue = activeButton ? activeButton.dataset.filter : 'all';
          
          const visibleCards = Array.from(cards).filter(card => {
            if (filterValue === 'all') {
              return true;
            }
            const cardCategories = card.dataset.categories;
            if (cardCategories) {
              const categoriesArray = cardCategories.split(',').map(cat => cat.trim());
              return categoriesArray.includes(filterValue);
            }
            return false;
          });

          handleShowMore(filterValue, visibleCards);
        }, 250);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["testimonial-text"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__testimonialTextBlockModalInit) return;
    window.__testimonialTextBlockModalInit = true;

    const tryPlayWithSound = (scope) => {
      const video = scope.querySelector('video');
      if (video) {
        try {
          video.muted = false;
          video.volume = 1;
          video.playsInline = true;
          const p = video.play();
          if (p && typeof p.catch === 'function') {
            p.catch(() => {
              video.muted = true;
              video.play().catch(() => {});
            });
          }
        } catch (e) {}
        return;
      }

      const iframe = scope.querySelector('iframe[data-video-type]');
      if (!iframe || !iframe.contentWindow) return;
      const type = iframe.dataset.videoType;
      try {
        if (type === 'youtube') {
          iframe.contentWindow.postMessage('{"event":"command","func":"unMute","args":""}', '*');
          iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
        } else if (type === 'vimeo') {
          iframe.contentWindow.postMessage('{"method":"setVolume","value":1}', '*');
          iframe.contentWindow.postMessage('{"method":"play"}', '*');
        }
      } catch (e) {}
    };

    document.addEventListener(
      'click',
      (event) => {
        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;
        if (!target.closest('.testimonial-text-block')) return;

        const openDialog = target.closest('dialog.testimonial-text-block__dialog[open]');
        if (openDialog) {
          const dialogComponent = openDialog.closest('dialog-component');
          if (!dialogComponent) return;
          if (target.closest('.testimonial-text-block__modal-video')) return;
          if (target.closest('.testimonial-text-block__dialog-close')) return;
          const dc = dialogComponent;
          if (typeof dc.closeDialog === 'function') dc.closeDialog();
          return;
        }

        const trigger = target.closest('.testimonial-text-block__video-trigger');
        if (!trigger) return;
        const dialogComponent = trigger.closest('dialog-component');
        if (!dialogComponent) return;
        const deferred = dialogComponent.querySelector('deferred-media.testimonial-text-block__modal-video, deferred-media');
        if (!deferred) return;
        try {
          if (typeof deferred.loadContent === 'function') deferred.loadContent(false);
          if (typeof deferred.playMedia === 'function') deferred.playMedia();
        } catch (e) {}
        tryPlayWithSound(deferred);
        dialogComponent.addEventListener('dialog:open', () => tryPlayWithSound(deferred), { once: true });
      },
      { capture: true }
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
